var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOutcomes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_7335)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.271973,
    width: 102.272,
    height: 102.272,
    rx: 51.136,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2001_7335)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.4561,
    y: 26.272,
    width: 72,
    height: 91,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4561,
    y: 58.272,
    width: 36,
    height: 16,
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4561,
    y: 90.272,
    width: 72,
    height: 16,
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4561,
    y: 62.272,
    width: 27,
    height: 2,
    rx: 1,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4561,
    y: 66.272,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4561,
    y: 66.272,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.4561,
    y: 42.272,
    width: 36,
    height: 16,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4561,
    y: 46.272,
    width: 27,
    height: 3,
    rx: 1,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4561,
    y: 74.272,
    width: 36,
    height: 16,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.4561,
    y: 58.272,
    width: 36,
    height: 32,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3753 77.0959C71.1566 77.3307 70.7373 77.3307 70.5186 77.0959C69.5889 76.0788 67.4561 73.6534 67.4561 72.2764C67.4561 70.6177 69.0238 69.272 70.9561 69.272C72.8883 69.272 74.4561 70.6177 74.4561 72.2764C74.4561 73.6534 72.3232 76.0788 71.3753 77.0959ZM70.9561 71.2749C70.5368 71.2749 70.154 71.4783 69.9352 71.7756C69.7347 72.0886 69.7347 72.4798 69.9352 72.7771C70.154 73.0901 70.5368 73.2778 70.9561 73.2778C71.3571 73.2778 71.7399 73.0901 71.9587 72.7771C72.1592 72.4798 72.1592 72.0886 71.9587 71.7756C71.7399 71.4783 71.3571 71.2749 70.9561 71.2749Z",
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4561,
    y: 78.272,
    width: 27,
    height: 2,
    rx: 1,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4561,
    y: 82.272,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.4561,
    y: 82.272,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4561,
    cy: 83.272,
    r: 1,
    fill: "#FF6C00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_7335"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.271973,
    width: 102.272,
    height: 102.272,
    rx: 51.136,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2001_7335"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.4561,
    y: 26.272,
    width: 72,
    height: 91,
    rx: 1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOutcomes);
export default __webpack_public_path__ + "static/media/no-outcomes.b66bef430f4174ba30e2d8544468048d.svg";
export { ForwardRef as ReactComponent };